import React from "react";
import Box, { BoxProps } from "../Box";
import Text from "../Text";

type Props = {
  title: string;
  message?: string | React.ReactNode;
  children?: React.ReactNode;
} & BoxProps;

const ModalHeader: React.FC<Props> = ({ title, message, children, ...rest }) => {
  return (
    <Box
      zIndex={20}
      background="white"
      borderBottom="default"
      as="header"
      pt="l"
      width="100%"
      display="block"
      {...rest}>
      <Box mx="xxl" textAlign="center" mb="m">
        <Text as="h1" font="ui.title">
          {title}
        </Text>
        {message ? (
          <Box my="s">
            <Text as="span" mt="s">
              {message}
            </Text>
          </Box>
        ) : null}
      </Box>
      {children}
    </Box>
  );
};

export default ModalHeader;
